var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.detail.array_value, function (c, i) {
      return _c(
        "div",
        { staticClass: "flex flex_gap_10 border-bottom mb-1 pb-1" },
        [
          _c("div", { staticClass: "flex-grow-1" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: c.comment,
                  expression: "c.comment",
                },
              ],
              staticClass: "form-control",
              attrs: { placeholder: "Новый комментарий", rows: "2" },
              domProps: { value: c.comment },
              on: {
                change: function ($event) {
                  return _vm.updateRecord(c)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(c, "comment", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "max_width_30" },
            [
              _c("label", { attrs: { for: "" } }, [
                _vm._v("Проекты (пусто = все проекты)"),
              ]),
              _vm._v(" "),
              _c("multiselect", {
                attrs: {
                  options: _vm.getActiveProjects(),
                  placeholder: "Выберите проект",
                  "track-by": "title",
                  label: "title",
                  showLabels: false,
                  searchable: true,
                  multiple: true,
                },
                on: {
                  input: function ($event) {
                    return _vm.updateRecord(c)
                  },
                },
                model: {
                  value: c.selected_projects,
                  callback: function ($$v) {
                    _vm.$set(c, "selected_projects", $$v)
                  },
                  expression: "c.selected_projects",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Действителен до")]),
              _vm._v(" "),
              _c("DateSelect", {
                attrs: {
                  "selected-date": c.valid_date,
                  onSelect: (d) => {
                    c.valid_date = d
                    _vm.updateRecord(c)
                  },
                  customShortCuts: true,
                  disabled: true,
                },
              }),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: c.permanent,
                      expression: "c.permanent",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(c.permanent)
                      ? _vm._i(c.permanent, null) > -1
                      : c.permanent,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = c.permanent,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && _vm.$set(c, "permanent", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              c,
                              "permanent",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(c, "permanent", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" бессрочный\n      "),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "action_btns" }, [
            c.saved
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-danger",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.removeRecord(i)
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
                )
              : _vm._e(),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }